/* eslint-disable import/no-unused-modules */
import React, { ComponentProps } from "react";
import {
  PenaltiesInfographicStepColor,
  Tag
} from "@silversea-ssc/ui-components-react";
import { Trans, useLingui } from "@lingui/react/macro";
import { match } from "ts-pattern";
import {
  formatPeriod,
  PaymentTerms
} from "features/cancellation-policy/helpers";
import { currentCancellationPeriod } from "src/utils/payment-terms-helpers";
import * as styles from "./fareCancellationPolicyStep.module.scss";

export const toCancellationPolicyFareInfographicStepInfo = (
  t: ReturnType<typeof useLingui>["t"],
  paymentTerms: PaymentTerms | undefined
) => {
  if (!paymentTerms) return undefined;
  const period = currentCancellationPeriod(paymentTerms);
  const cancellationAdminFee = paymentTerms.cancellationAdminFee;
  if (!period) return undefined;

  const penaltyInfo = formatPeriod(
    t,
    period,
    paymentTerms.currency,
    cancellationAdminFee,
    false
  );
  const tagProps = match<
    PenaltiesInfographicStepColor,
    ComponentProps<typeof Tag>
  >(penaltyInfo.color)
    .with("green", () => ({
      variant: "success",
      children: <Trans>Flexible</Trans>
    }))
    .with("yellow03", () => ({
      variant: "warning",
      children: <Trans>Moderate</Trans>
    }))
    .with("red", () => ({
      variant: "negative",
      children: <Trans>Strict</Trans>
    }))
    .exhaustive();

  return {
    description: penaltyInfo.label,
    tag: <Tag className={styles.tagMarginFixed} {...tagProps} />
  };
};
